import { sendToApi } from 'api/client'

export enum FileMoveAttemptResult {
  NoChange = 'no_change',
  PermissionsWillChange = 'permissions_will_change',
  WorkflowExistsOnCurrentFolder = 'workflow_exists_on_current_folder',
  ActiveReviewWithinCurrentFolder = 'active_review_within_current_folder',
}

export const FileMoveAttemptsClient = {
  create: ({
    folderIds,
    articleIds,
    destinationFolderId,
    destinationWorkspaceId,
    originalWorkspaceId,
  }: {
    folderIds: string[]
    articleIds: string[]
    destinationFolderId: string | null
    destinationWorkspaceId: number
    originalWorkspaceId: number
  }) =>
    sendToApi<FileMoveAttemptResult>(`/file_move_attempts`, {
      body: {
        folder_ids: folderIds,
        article_ids: articleIds,
        destination_folder_id: destinationFolderId,
        destination_workspace_id: destinationWorkspaceId,
        original_workspace_id: originalWorkspaceId,
      },
      method: 'POST',
    }),
}
